<template>
    <rkm-form
        v-if="loaded"
        ref="Form"
    >
        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-checkbox
                    v-model="model.ativo"
                >
                    Ativo
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row class="mt-2">
            <rkm-col cols="12">
                <rkm-form-input
                    :validations="validations.urlInstalacao"
                    label="URL da instalação do e-SUS"
                    v-model="model.urlInstalacao"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="4">
                <rkm-form-input
                    :validations="validations.usuario"
                    label="Usuário"
                    v-model="model.usuario"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :validations="validations.senha"
                    @change="model.confirmacaoSenha = null"
                    label="Senha"
                    type="password"
                    v-model="model.senha"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    :disabled="!model.senha"
                    :validations="validations.confirmacaoSenha"
                    label="Confirmar senha"
                    type="password"
                    v-model="model.confirmacaoSenha"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Others.
import { mapActions } from 'vuex'
import { object, stringCase, repository, error } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                urlInstalacao: { required: this.model.ativo, max: 255 },
                usuario: { required: this.model.ativo, max: 100 },
                senha: { required: this.model.ativo, max: 100 },
                confirmacaoSenha: { required: this.model.senha, is: this.model.senha, max: 100 },
            }
        }
    },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('integracao.esus.parametrizacao'),
        }

        this.load()
    },
    data: () => ({
        loaded: false,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.parametrizacao.create()
                .then(({ data }) => {

                    this.model = data.model

                    this.$emit('data-load', { model: this.model })

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                    this.setLoading()

                    this.repositories.parametrizacao.store(this.prepareData())
                        .then(() => {

                            this.$emit('save')
                            this.showSaveNotification()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
        prepareData() {

            const data = this.clone(this.model)

            delete data.confirmacaoSenha

            return this.camelObjectKeysToSnakeRecursive(data)
        }
    },
    mixins: [object, stringCase, repository, error]
}
</script>